import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=60a80ea5&scoped=true&"
import script from "./TrendChart.vue?vue&type=script&lang=js&"
export * from "./TrendChart.vue?vue&type=script&lang=js&"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=60a80ea5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a80ea5",
  null
  
)

export default component.exports